import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { LengthDto } from '../dtos/models';

@Injectable({
  providedIn: 'root',
})
export class LengthService {
  private readonly restService = inject(RestService);
  apiName = 'Default';
  

  getAll = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, LengthDto[]>({
      method: 'GET',
      url: '/api/app/length',
    },
    { apiName: this.apiName,...config });
}